import { cx } from 'emotion';
import { range } from 'ramda';
import React from 'react';

import StarIcon from './assets/Star.png';
import {
  Container, confettiAnimation, starClassName, STARS, CONFETTI,
} from './style';
import { getRandomInRange } from './util';

const getConfettiStyle = () => {
  const size = getRandomInRange(10, 20);

  return {
    top: `${getRandomInRange(-10, 60)}%`,
    left: `${getRandomInRange(5, 95)}%`,
    width: `${size}px`,
    height: `${size}px`,
  };
};

const getConfetti = () => (
  range(0, 20).map((_, i) => (
    <img
      key={`confetti-${i}`}
      src={CONFETTI[i % 5].icon}
      style={getConfettiStyle()}
      className={cx(confettiAnimation, CONFETTI[i % 5].className)}
    />
  ))
);

const getStars = () => (
  range(0, 5).map((_, i) => (
    <img key={`star${i}`} src={StarIcon} className={cx(starClassName, STARS[i])} />
  ))
);

const WinAnimation = (props) => (
  <Container data-name="win-animation" {...props}>
    {getStars()}
    {getConfetti()}
  </Container>
);

export default WinAnimation;
